// redux to create the store
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
//middlewares
import thunk from 'redux-thunk';
import createLogger from 'redux-logger';
// reducers
import app from './app-dux.js';
import headerState from './header/header-dux.js';
import footer from './footer/footer-dux.js';
import login from './login/login-dux.js';
import forgotPassword from './forgot-password/forgot-password-dux.js';
import updatePassword from './update-password/update-password-dux.js';
import emailVerification from './email-verification/email-verification-dux.js';
import enroll from './enroll/enroll-dux.js';
import profile from './profile/profile-dux.js';
import termsAndCond from './terms-conditions/terms-conditions-dux.js';
import privacyPolicy from './privacy-policy/privacy-policy-dux.js';
import faq from './faq/faq-dux.js';
import contact from './contact-us/contact-dux.js';
import news from './news/news-dux.js';
import sales from './sales-tools/sales-tools-dux.js';
import spinwin from './spin2win/spin-win-dux.js';
import views from './views/views-dux.js';
import refer from './refer-earn/referAndEarn-dux.js';

const appReducers = combineReducers( {
    app,
    headerState,
	footer,
	login,
	forgotPassword,
	updatePassword,
	emailVerification,
	enroll,
	profile,
	termsAndCond,
	privacyPolicy,
	faq,
	contact,
	news,
	sales,
    spinwin,
	views,
	refer
} );

/*
 * thunk is a required middleware for the app
 */
const middlewares = [ thunk ];

/*
 * if we are running npm run prod, we do not add the createLogger middleware
 * createLogger will run in debug mode on pprd or qa,
 * just append ?debug=y to the url
 */
if ( process.env.NODE_ENV !== 'production' ) {
  const logger = createLogger();
  middlewares.push( logger );
}

const AppStore = createStore(
    appReducers,
    compose(
        applyMiddleware( ...middlewares ),
        typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : f => f
    )
);

export default AppStore;



// WEBPACK FOOTER //
// ./src/app-store.js